/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface ElementCharacteristics
 */
export interface ElementCharacteristics {
  /**
   *
   * @type {object}
   * @memberof ElementCharacteristics
   */
  data: object;
}

/**
 * Check if a given object implements the ElementCharacteristics interface.
 */
export function instanceOfElementCharacteristics(value: object): value is ElementCharacteristics {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function ElementCharacteristicsFromJSON(json: any): ElementCharacteristics {
  return ElementCharacteristicsFromJSONTyped(json, false);
}

export function ElementCharacteristicsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ElementCharacteristics {
  if (json == null) {
    return json;
  }
  return {
    data: json['data']
  };
}

export function ElementCharacteristicsToJSON(value?: ElementCharacteristics | null): any {
  if (value == null) {
    return value;
  }
  return {
    data: value['data']
  };
}
